import { immer } from 'zustand/middleware/immer';
import { createStore } from 'zustand/vanilla';

import { setSignUpStepLocalStorage } from '@/utils/localStorage/signUpStepLocalStorage';

import { UserType } from '@/types/userType';

// Types
import { SIGN_UP } from '@/lib/routes/privateRoutes';

export type SignUpStepType = keyof typeof SIGN_UP | 'SIGN_UP_DONE';

export type SignUpStoreStateType = {
    currentStep: SignUpStepType;
};

export type SignUpStoreActionsType = {
    updateCurrentStep: (step: SignUpStepType, userId?: UserType['id']) => void;
};

export type SignUpStoreType = SignUpStoreStateType & SignUpStoreActionsType;

export const defaultInitState: SignUpStoreStateType = {
    currentStep: null
};

export const createSignUpStore = (initState: SignUpStoreStateType = defaultInitState) => {
    return createStore<SignUpStoreType>()(
        immer((set) => ({
            ...initState,
            updateCurrentStep: (step, userId) => {
                set((state) => {
                    state.currentStep = step;
                });

                if (userId) {
                    setSignUpStepLocalStorage(step, userId);
                }
            }
        }))
    );
};
